'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'], function (Vue) {
	Vue.component('question-edit', {
		props: ['question', 'index', 'removeQuestion', 'initData'],
		data: function () {
			return {
				accordion: 'question' + this.index,
				accordionHref: '#question' + this.index,
				heading: 'heading' + this.index,
				maxAnswers: 10,
				selectAnswersCount: 10,
				selectAnswers: [],
			};
		},
		watch: {
			selectAnswersCount: function (count) {
				if (this.question.answers.length > count) {
					this.question.answers.splice(count);
				} else if (this.question.answers.length < count) {
					this.addAnswers(count - this.question.answers.length);
				}
			},
		},
		mounted: function () {
			this.question.el = this.$el;
			this.selectAnswersCount = this.question.answers.length || this.maxAnswers;

			this.initAnswersSelect();
		},
		methods: {
			initAnswersSelect: function () {
				this.selectAnswers = [];

				for (var i = 2; i <= this.maxAnswers; i++) {
					this.selectAnswers.push(i);
				}

				if (!this.question.answers.length) {
					this.addAnswers(this.maxAnswers);
				}
			},
			addAnswers: function (count) {
				var destination = this.question.answers.length + count;

				for (var i = this.question.answers.length + 1; i <= destination; i++) {
					this.question.answers.push({ weight: i, label: '' });
				}
			},
		},
		template:
			'<div class="panel panel-default">' +
				'<div class="panel-heading" role="tab" :id="heading">' +
					'<h4 class="panel-title">' +
						'<a role="button" data-toggle="collapse" data-parent="#questions" :href="accordionHref" aria-expanded="false" :aria-controls="accordion">' +
							'{{initData.translations.question}}: {{question.question}}' +
						'</a>' +
						'<button type="button" v-on:click="removeQuestion(question)" class="btn btn-xs btn-danger pull-right">{{initData.translations.removeQuestion}}</button>' +
					'</h4>' +
				'</div>' +
				'<div :id="accordion" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="heading">' +
					'<div class="panel-body">' +
						'<div class="row">' +
							'<div class="col-xs-10">' +
								'<label for="name">{{initData.translations.question}}</label>' +
								'<input type="text" class="form-control" v-model="question.question" :placeholder="initData.translations.questionPlaceholder" />' +
							'</div>' +
							'<div class="col-xs-2">' +
								'<label for="name">{{initData.translations.answers}}</label>' +
								'<select class="form-control" v-model="selectAnswersCount">' +
									'<option v-for="answer in selectAnswers" :value="answer">{{answer}}</option>' +
								'</select>' +
							'</div>' +
						'</div>' +
						'<question-edit-answers :question="question" :init-data="initData"></question-edit-answers>' +
					'</div>' +
				'</div>' +
			'</div>',
	});
});
